import { render, staticRenderFns } from "./DefaultIcon.vue?vue&type=template&id=69623f3e&scoped=true"
import script from "./DefaultIcon.vue?vue&type=script&lang=js"
export * from "./DefaultIcon.vue?vue&type=script&lang=js"
import style0 from "./DefaultIcon.vue?vue&type=style&index=0&id=69623f3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69623f3e",
  null
  
)

export default component.exports